import $ from "jquery";

var store = window.sessionStorage;
var $html = $("html");
var $alertBtnClose = $(".js--alert-close");
var alertStoreKey = "nrmpalert";

if (!store[alertStoreKey]) {
  $html.addClass("has-alert");
}

$alertBtnClose.on("click", function () {
  $html.removeClass("has-alert");
  store.setItem(alertStoreKey, true);
});
